import React from 'react'

type Props = {
  pleaseWaitPopup: boolean;
}

export default function PleaseWaitPopup({
  pleaseWaitPopup
}: Props) {

  if (!pleaseWaitPopup) return null;

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-black/40 px-4">

      <div className="w-full max-w-[320px] rounded-xl bg-white p-6 shadow-2xl">

        <div className="flex flex-col items-center justify-center gap-4">

          <div className="h-10 w-10 animate-spin rounded-full border-4 border-[#167AC3] border-t-transparent" />

          <p className="text-base font-medium text-gray-700">
            Please Wait...
          </p>

        </div>
      </div>
    </div>
  )
}